import {
  checkIsFeeProviderMissedFields,
  checkIsLocationEmpty,
} from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/ClosingCompany/ClosingCompany.utils';
import _ from 'lodash';

import { TRUST_ENTITY_NAMES_NUMBER } from 'constants/loanApplication';

import { REQUIRED_TRUST_ENTITY_TYPES } from '../../Content.constants';
import { extractCompanyFormData } from '../../Content.utils';

const hasEmptyLocation = (formData, company, prefix) => {
  const data = extractCompanyFormData(formData, prefix, company);

  return !!data.attendantCompanyId && checkIsLocationEmpty({ form: data, isAddAttorneys: false });
};

const hasMissedFields = (formData, company, prefix) => {
  const data = extractCompanyFormData(formData, prefix, company);

  return (
    !!data.attendantCompanyId &&
    checkIsFeeProviderMissedFields({ form: data, isAddAttorneys: false })
  );
};

export const validateTitleCompanySection = (
  allFormData,
  { titleCompany, escrowCompany, sellerAttorney, buyerAttorney },
) => {
  const isLocationEmpty =
    hasEmptyLocation(allFormData, titleCompany, 'title') ||
    hasEmptyLocation(allFormData, escrowCompany, 'escrow') ||
    hasEmptyLocation(allFormData, sellerAttorney, 'sellerAttorney') ||
    hasEmptyLocation(allFormData, buyerAttorney, 'buyerAttorney');

  if (isLocationEmpty) {
    return { message: 'Please select a location for the company', variant: 'warning' };
  }

  const isMissedFields =
    hasMissedFields(allFormData, titleCompany, 'title') ||
    hasMissedFields(allFormData, escrowCompany, 'escrow') ||
    hasMissedFields(allFormData, sellerAttorney, 'sellerAttorney') ||
    hasMissedFields(allFormData, buyerAttorney, 'buyerAttorney');

  if (isMissedFields) {
    return { message: 'Fee provider is missing required address fields', variant: 'warning' };
  }

  return null;
};

export const validateTitleHolderSection = (allFormData, { isTrustSectionVisible }) => {
  if (!isTrustSectionVisible) {
    return null;
  }

  const emptyGroups = REQUIRED_TRUST_ENTITY_TYPES.filter(
    group =>
      !Array.from({ length: TRUST_ENTITY_NAMES_NUMBER }).some((__, i) =>
        _.trim(allFormData[`${group}${i + 1}`]),
      ),
  );

  if (emptyGroups.length) {
    return {
      message: `At least one ${emptyGroups.join(', ')} should be provided`,
      variant: 'error',
    };
  }

  return null;
};
